<div class="ps-1 pe-1">
  <app-alert
    *ngFor="let alert of alerts"
    [type]="alert.type"
    [message]="alert.message"
    [alertId]="alert.id"
    [dismissedAfter]="alert.dismissedAfter"
    (alertClosed)="onAlertClosed(alert.id)"></app-alert>
</div>
